import { invalidateSingleEntryCache } from 'api/urql/helpers/mutation';

export const deleteJobRequestTemplate = (results, args, cache, info) => {
  // handlers go here
  invalidateSingleEntryCache('JobRequestTemplate')(
    results,
    args,
    cache,
    info
  );
};
